// トークチャンネル最大個数
export const TALK_ROOM_GROUP_MAX = 50;

// トークDM最大個数
// https://fincs.backlog.com/view/FINCS-3851
export const TALK_ROOM_DM_MAX = 10000;

// トークチャンネル+DM+アーカイブ最大個数
// https://fincs.backlog.com/view/FINCS-3229
export const TALK_ROOM_TOTAL_MAX = TALK_ROOM_DM_MAX + 2500;

// トークアーカイブ最大個数
export const TALK_ROOM_ARCHIVE_MAX = TALK_ROOM_TOTAL_MAX - TALK_ROOM_GROUP_MAX - TALK_ROOM_DM_MAX;

// トークルームの日付表示フォーマット
export const TALK_DATE_FORMAT = "M/d(E)";

// トーク入力最大文字数
export const TALK_INPUT_TEXT_MAX = 5000;

// トーク返信最大文字数
export const TALK_REPLY_TEXT_MAX = 270;

// トークスレッド ID 未設定値
export const TALK_THREAD_ID_NONE = "0";

// トークスレッドタブ内子トーク最大個数
export const TALK_THREAD_TAB_CHILD_DISP_MAX = 2;

// トークスレッドタブクエリ最大数
// 他のユーザーデータより重いので数を絞る
export const TALK_THREAD_TAB_QUERY_MAX = 5;

// トークユーザーデータクエリ最大数
export const TALK_USER_DATA_QUERY_MAX = 10;

// トークユーザーデータ項目テキスト最大文字数
export const TALK_USER_DATA_ITEM_TEXT_MAX = 50;

// トークブックマークのルームごと最大個数
export const TALK_BOOKMARK_PER_ROOM_MAX = 30;

// トークメンション用プレースホルダー
export const TALK_MENTION_PLACEHOLDER = "<mention>";

// トークメンション候補最大数
export const TALK_MENTION_USERS_MAX = 20;
